<div fxLayout="row wrap">
  <Teranet-PageTitle [PageTitle]="title"></Teranet-PageTitle>
  <mat-divider></mat-divider>
</div>
<div mat-dialog-content>
  <div fxLayout="column">
    <div class="teranet-padding" fxFlex="100" fxLayout="column">
      <form [formGroup]="ipFilteringForm"
            #ipFilteringFormRef="ngForm"
            novalidate
            (ngSubmit)="createOrUpdateIpFiltering(ipFilteringFormRef)">
        <div fxFlex="100">
          <div fxLayout="column" fxLayoutAlign="center stretch">
            <div fxLayout.xs="column" fxLayout="row wrap">
              <div class="form-group-flex-column">
                <mat-label class="required-field-after">Corporation</mat-label>
                <mat-form-field appearance="outline">
                  <mat-select required formControlName="clientInfoId" placeholder="--Please Select--">
                    <mat-option *ngFor="let ci of clientInfos" [value]="ci.id">
                      {{ ci.description }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="!isEdit && ipFilteringForm.get('clientInfoId').hasError('required')">
                    {{ ipFilteringEditErrorMessage.CORPORATION_REQUIRED }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div fxLayout.xs="column" fxLayout="row wrap">
              <div class="form-group-flex-column">
                <mat-label class="label-title">Filter Name</mat-label>
                <mat-form-field appearance="outline">
                  <input matInput
                         data-lpignore="true"
                         formControlName="ipFilterName"
                         #ipFilterName />
                  <mat-error *ngIf="ipFilteringForm.get('ipFilterName').hasError('maxlength')">
                    {{ ipFilteringEditErrorMessage.FIRST_NAME_MAX_LENGTH + ipFilteringForm.get('ipFilterName').errors.maxlength.requiredLength }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div fxLayout.xs="column" fxLayout="row wrap">
              <div class="form-group-flex-column">
                <mat-label class="required-field-after">Filter From</mat-label>
                <mat-form-field appearance="outline">
                  <input matInput
                         data-lpignore="true"
                         formControlName="ipFilterStart"
                         required
                         #ipFilterStart />
                  <mat-error *ngIf="ipFilteringForm.get('ipFilterStart').hasError('required')">
                    {{ ipFilteringEditErrorMessage.IP_FILTER_START_REQUIRED }}
                  </mat-error>
                  <mat-error *ngIf="ipFilteringForm.get('ipFilterStart').hasError('pattern')">
                    {{ ipFilteringEditErrorMessage.IP_FILTER_TYPE }}
                  </mat-error>
                  <mat-error *ngIf="
                      ipFilteringForm.get('ipFilterStart').errors?.min &&
                      ipFilteringForm.get('ipFilterEnd').errors?.min
                    ">
                    {{ ipFilteringEditErrorMessage.IP_FILTER_START_IP_FILTER_TO_COMPARASION }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-group-flex-column">
                <mat-label class="required-field-after">Filter To</mat-label>
                <mat-form-field appearance="outline">
                  <input matInput
                         data-lpignore="true"
                         formControlName="ipFilterEnd"
                         required
                         #ipFilterEnd />
                  <mat-error *ngIf="ipFilteringForm.get('ipFilterEnd').hasError('required')">
                    {{ ipFilteringEditErrorMessage.IP_FILTER_END_REQUIRED }}
                  </mat-error>
                  <mat-error *ngIf="ipFilteringForm.get('ipFilterEnd').hasError('pattern')">
                    {{ ipFilteringEditErrorMessage.IP_FILTER_TYPE }}
                  </mat-error>
                  <mat-error *ngIf="
                      ipFilteringForm.get('ipFilterStart').errors?.min &&
                      ipFilteringForm.get('ipFilterEnd').errors?.min
                    ">
                    {{ ipFilteringEditErrorMessage.IP_FILTER_TO_IP_FILTER_START_COMPARASION }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div fxLayout.xs="column" fxLayout="row wrap">
              <div class="form-group-flex-column">
                <mat-checkbox formControlName="isActive" class="checkbox-margin">Is Active</mat-checkbox>
              </div>
            </div>
          </div>
          <div fxLayout="row wrap" fxLayoutAlign="end">
            <button mat-raised-button class="plain-button" type="button" (click)="onClose()">Cancel</button>
            <button mat-raised-button class="theme-button" type="submit">Save</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
